import { render, staticRenderFns } from "./contactContent.vue?vue&type=template&id=8a1b5106&scoped=true&"
import script from "./contactContent.vue?vue&type=script&lang=js&"
export * from "./contactContent.vue?vue&type=script&lang=js&"
import style0 from "./contactContent.vue?vue&type=style&index=0&id=8a1b5106&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1b5106",
  null
  
)

export default component.exports